// @flow
import * as React from 'react';
import MiniFlow from '@screens/HowItWorks/components/MiniFlow';
import compose from 'lodash/fp/compose';
import { withTranslation } from '@i18n';
import { NextSeo } from 'next-seo';
import { useBreakpoint } from '@lib/hooks';
import { YAPITA_HEALTH_URL } from '@routes';

const OnlineConsultation = ({ t }): any => {
  const isMobile = useBreakpoint('mobile', 'desktop');

  const metaData: { MetaTitle: string, MetaDescription: string } = t('Seo:OnlineConsultation', {
    returnObjects: true
  });

  return (
    <>
      <NextSeo
        title={metaData.MetaTitle}
        description={metaData.MetaDescription}
        canonical={`${YAPITA_HEALTH_URL}/en/online-consultation`}
        openGraph={{
          url: `${YAPITA_HEALTH_URL}/en/online-consultation`,
          title: metaData.MetaTitle,
          description: metaData.MetaDescription,
          images: [
            {
              url: 'https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapita-health-og.jpg',
              width: 800,
              height: 600,
              alt: 'Yapita Health - Your Medical Partner',
              type: 'image/jpg'
            }
          ],
          siteName: 'Yapita Health'
        }}
        twitter={{
          handle: '@yapitahealth',
          site: '@yapitahealth',
          cardType: 'summary_large_image'
        }}
      />
      <MiniFlow isMobile={isMobile} />
    </>
  );
};

export default compose(withTranslation('DetailsJob'))(OnlineConsultation);
